<template>
	<div>
		<div class="workingHours-container" dir="ltr">
			<div v-if="date.length" class="workingHours-inner" dir="rtl">
				<working-hours
					:date="date"
					:weekNames="weekNames"></working-hours>
			</div>
			<div v-else class="d-flex flex-column align-center text-center mt-6">
				<v-icon size="30" color="black" class="mb-2">ico-calendar</v-icon>
				لا يوجد برنامج دوام
			</div>
		</div>
	</div>
</template>

<script>
import WorkingHours from '@/components/WorkingHours';
import moment from 'moment';

export default {
	name: 'ScheduleView',

	components: { WorkingHours },

	data() {
		return {
			date: [],
			weekNames: [
				'الجمعة',
				'السبت',
				'الأحد',
				'الأثنين',
				'الثلاثاء',
				'الأربعاء',
				'الخميس',
			],
		};
	},

	methods: {
		fetch() {
			this.$eventBus.$emit('page-loader', true);
			this.$store
				.dispatch('schedule/fetchSchedule')
				.then((res) => {
					const schedule = res.map(c => ({
						...c,
						StartDate:
							moment(c.StartDate)
								.set({ date: 1, month: 0, year: 2000 })
								.toDate().getTime(),
					}));

					// costmaize the dates
					this.date = schedule.map((item) => {
						return {
							class: item.RoomName,
							name: item.SubjectName,
							teacher: item.TeacherName,
							x: this.weekNames[item.Day],
							y: [
								new Date(item.StartDate).getTime(),
								new Date(
									item.StartDate + item.Duration * 1000 * 60,
								).getTime(),
							],
						};
					});
				})
				.finally(() => {
					this.$eventBus.$emit('page-loader', false);
				});
		},
	},
	mounted() {
		this.fetch();
	},
};
</script>

<style scoped>
.workingHours-container {
	width: 100%;
	overflow-x: auto;
}
.workingHours-inner {
	min-width: 1000px;
	overflow: hidden;
}
</style>
